/*
  Seção HALO Abas (sections/halo-abas.liquid).
  Abas no padrão de acessibilidade (tablist): clique ou setas do teclado trocam o painel. O
  endereço com #âncora (ex.: #band) abre a aba com essa âncora, também quando o # muda. Ao trocar
  de aba, o endereço passa a ter a âncora dela, sem rolar a página. No editor de tema, escolher um
  bloco abre a aba dele.
*/
(function () {
  'use strict';

  function tabsOf(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
  }

  function activate(root, tab, opts) {
    var options = opts || {};
    tabsOf(root).forEach(function (t) {
      var on = t === tab;
      t.classList.toggle('is-ativa', on);
      t.setAttribute('aria-selected', String(on));
      t.tabIndex = on ? 0 : -1;
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) panel.hidden = !on;
    });
    if (options.focus) tab.focus();
    if (options.hash && tab.dataset.ancora && window.history && history.replaceState) {
      history.replaceState(null, '', '#' + tab.dataset.ancora);
    }
  }

  function fromHash(root) {
    var hash = decodeURIComponent((window.location.hash || '').replace(/^#/, '')).toLowerCase();
    if (!hash) return;
    var tab = tabsOf(root).filter(function (t) {
      return (t.dataset.ancora || '').toLowerCase() === hash;
    })[0];
    if (tab) activate(root, tab);
  }

  function init(root) {
    if (!root || root.haloAbas) return;
    var tabs = tabsOf(root);
    if (tabs.length < 2) return;
    root.haloAbas = true;

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        activate(root, tab, { hash: true });
      });
      tab.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        else if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (e.key === 'Home') next = tabs[0];
        else if (e.key === 'End') next = tabs[tabs.length - 1];
        if (!next) return;
        e.preventDefault();
        activate(root, next, { focus: true, hash: true });
      });
    });

    fromHash(root);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-halo-abas]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  window.addEventListener('hashchange', function () {
    document.querySelectorAll('[data-halo-abas]').forEach(fromHash);
  });

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });

  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest && e.target.closest('[data-halo-abas]');
    if (!root) return;
    var panel = e.target.closest('[role="tabpanel"]');
    if (!panel) return;
    var tab = document.getElementById(panel.getAttribute('aria-labelledby'));
    if (tab) activate(root, tab);
  });
})();
